import api from '../../service/modules/complaint';
import Api from '../../service/modules/complaintApis';
import util from '@/utils/common';
function formatCityProp(citys) {
  const citysCopy = JSON.parse(JSON.stringify(citys));
  return citysCopy.map((item) => {
    let children = [
      {
        areaId: item.areaId,
        key: item.areaId,
        label: '全部',
        text: '全部',
        children: []
      }
    ];
    if (item.children && item.children.length) {
      const allChildrens = formatCityProp(item.children);
      children.push(...allChildrens);
    }
    return {
      areaId: item.areaId,
      value: item.code,
      label: item.allName,
      text: item.allName,
      children
    };
  });
}

/**
 * 核心格式化逻辑：将根节点（如云南省）及其直接下级（各州市）全部提升为第一列（平级）。
 * 且强制丢弃原本的第三层数据（区县），只保留两层级联。
 */
function formatTwoLevelRegion(root) {
  if (!root) return [];

  // 接口可能返回单节点（无 children），需兜底成可选列表
  if (!root.children || !root.children.length) {
    return [
      {
        text: root.name || root.allName || "",
        id: root.areaId,
        children: []
      }
    ];
  }

  const rawChildren = root.children || [];

  // 无子级的叶子选项 (如：全部、省级)
  const leafOptions = rawChildren.filter(item => !item.children || item.children.length === 0);
  // 有子级的分支项 (如：昆明市、曲靖市)
  const branchOptions = rawChildren.filter(item => item.children && item.children.length > 0);

  const flatList = [];

  // 叶子选项在前
  leafOptions.forEach(opt => {
    flatList.push({ text: opt.name, id: opt.areaId, children: [] });
  });

  // 分支项在后，带上 children
  branchOptions.forEach(city => {
    flatList.push({
      text: city.name,
      id: city.areaId,
      children: (city.children || []).map(child => ({ text: child.name, id: child.areaId }))
    });
  });

  return flatList;
}
export default {
  namespaced: true,
  state: {
    basicImformation: '',
    mobile: '15623556684',
    userInfo: util.getJsonLocal('userInfoComplaint') || {}, // 用户信息
    deptInfo: util.getJsonLocal('deptInfoComplaint') || {}, // 部门信息
    userId: '',
    item: '', // 每条列表
    type: '', // 机构类型
    addType: [], // 新增机构类型
    isHandleWorkbench: '', // 处理组有处置工作台,
    selectCommand: [], // 查询公司
    isShowBottom: false, // 详情页底部的动画
    listType: '', // 列表详情
    workType: '', // 处理工作台
    // statusInfo: '' // 上报后再详情列表需要展示的信息
    listObjItem: '',
    todayType: '',
    isCheckList: false,
    isBackDetail: false,
    returnKey: '',
    channerList: [], // 投诉渠道
    cityList: util.getJsonLocal('areaListComplaint') || [], // 行政区域
    // 可视化仪表盘全局筛选参数
    visualFilter: {
      areaId: '',
      beginTime: '',
      endTime: '',
      channel: '',
      rule: ''
    },
    allRegionIncludeSelf: util.getJsonLocal('allRegionIncludeSelfComplaint') || [], // 获取账号当前所属行政区域的所有下级区域（包含本级）
    rawRegionTree: null, // 保存接口返回的原始区域树数据，用于 areaId → code 反查
    currentVisualAreaLevel: '1' // 记录当前可视化数据对应的账号权限层级 (1: 省级, 2: 州市级)
  },
  mutations: {
    setUserInfo: (state, data) => {
      // 存储用户信息
      Object.keys(state.userInfo).forEach((prop) => {
        delete state.userInfo[prop];
      });
      state.userInfo = Object.assign({}, state.userInfo, data);
      util.setJsonLocal('userInfoComplaint', data);
    },
    setDeptInfo: (state, data) => {
      // 存储用户组织信息
      if (state.deptInfo) {
        Object.keys(state.deptInfo).forEach((prop) => {
          delete state.deptInfo[prop];
        });
      }
      state.deptInfo = Object.assign({}, state.deptInfo || {}, data || {});
      util.setJsonLocal('deptInfoComplaint', state.deptInfo);
    },
    getbasicImformation: (state, data) => {
      // 获取基础信息
      state.basicImformation = data;
    },
    getItemList: (state, data) => {
      state.item = data;
    },
    getType: (state, data) => {
      state.type = data;
    },
    addType: (state, data) => {
      state.addType.push(data);
    },
    resetType: (state, data) => {
      state.addType = data;
    },
    setHandleWorkbench: (state, data) => {
      state.isHandleWorkbench = data;
      util.setJsonLocal('setWorkType', data);
    },
    getCommand: (state, data) => {
      state.selectCommand = data;
    },
    setShowBottom: (state, data) => {
      state.isShowBottom = data;
    },
    setListType: (state, data) => {
      state.isShowBottom = data;
    },
    setWorkType: (state, data) => {
      state.workType = data;
    },
    getObjList: (state, data) => {
      state.listObjItem = data;
    },
    setTodayType: (state, data) => {
      state.todayType = data;
    },
    setCheckList: (state, data) => {
      state.isCheckList = data;
    },
    setBackDetail: (state, data) => {
      state.isCheckList = data;
      util.setJsonLocal('isBack', data);
    },
    setKey: (state, data) => {
      state.returnKey = data;
    },
    setChanner: (state, data) => {
      // 投诉渠道
      state.channerList = [];
      let arr = [];
      data.list.map((item) => {
        arr.push({
          text: item.name,
          value: item.code
        });
      });
      state.channerList.push(arr);
    },
    setCity: (state, data) => {
      // 行政区域
      state.cityList.splice(0, state.cityList.length);
      state.cityList.push(...data);
      util.setJsonLocal('areaListComplaint', data);
    },
    setVisualFilter: (state, data) => {
      // 可视化仪表盘全局筛选参数
      state.visualFilter = { ...state.visualFilter, ...data };
    },
    resetVisualFilter: (state) => {
      state.visualFilter = {
        areaId: '',
        beginTime: '',
        endTime: '',
        channel: '',
        rule: ''
      };
    },
    setAllRegionIncludeSelf: (state, data) => { // 存储所有级别行政区域列表
      state.allRegionIncludeSelf = data || [];
      util.setJsonLocal('allRegionIncludeSelfComplaint', data);
    },
    resetAllRegionIncludeSelf: (state) => { // 重置列表
      state.allRegionIncludeSelf = [];
      util.removeLocal('allRegionIncludeSelfComplaint');
    },
    setCurrentVisualAreaLevel: (state, level) => { // 存储当前可视化层级
      state.currentVisualAreaLevel = level;
    },
    setRawRegionTree: (state, data) => { // 存储接口返回的原始区域树
      state.rawRegionTree = data;
    }
  },
  actions: {
    setDeptInfo: (context, data) => {
      context.commit('setDeptInfo', data);
      if (!data) return;
      const params = {
        data: {
          cityCode: data.txId
        }
      };
      context.dispatch('region', params);
    },
    userReturnTotal: (context, data) => {
      api.detailsInfo(data).then((res) => {
        context.commit('getbasicImformation', res.data.basicDetails);
      });
    },
    channerList: (context, data) => {
      // 投诉渠道
      return new Promise((resolve, reject) => {
        Api.common.getComplainChannel({}).then((res) => {
          if (res.ret === 0) {
            context.commit('setChanner', res.data);
            resolve();
          }
        });
      });
    },
    region: (context, params = {}) => {
      // 行政区域划分
      return new Promise((resolve, reject) => {
        // 如果已经缓存了就不请求了
        if (
          context.state.cityList.length &&
          params.data.cityCode === context.state.cityList[0].areaId
        ) {
          resolve(JSON.parse(JSON.stringify(context.state.cityList)));
          return;
        }
        Api.common
          .getListRegion(params)
          .then((res) => {
            if (res.ret === 0) {
              const data = res.data.list;
              // 当前用户所属城市下级城市列表
              const areaList = [];
              const deptInfo = context.state.deptInfo;
              if (deptInfo.areaLevel === '1') {
                let province = Object.create(null);
                province.areaId = context.state.deptInfo.txId;
                province.allName = deptInfo.areaName;
                province.code = deptInfo.areaCode;
                province.areaLevel = deptInfo.areaLevel;
                province.name = deptInfo.txId;
                province.children = [];
                const cityArrCopy = formatCityProp([
                  province,
                  ...data.children
                ]);
                areaList.push(...cityArrCopy);
              } else if (deptInfo.areaLevel === '2') {
                // 省级权限
                const cityArrCopy = formatCityProp([data]);
                areaList.push(...cityArrCopy);
              } else {
                // 区县权限
                const obj = {
                  areaLevel: data.areaLevel,
                  areaId: data.areaId,
                  value: data.code,
                  key: data.areaId,
                  label: data.allName,
                  text: data.allName,
                  children: []
                };
                areaList.push(obj);
              }
              context.commit('setCity', areaList);
              resolve(JSON.parse(JSON.stringify(areaList)));
            } else {
              reject(res);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAllRegionIncludeSelf: (context) => { // 获取包含本级的所有下级行政区域
      return new Promise((resolve, reject) => {
        // 如果已经缓存
        // 强制重新请求数据，不使用缓存（避免旧格式缓存导致 UI 异常）
        Api.visualization.getAllRegionIncludeSelf().then(res => {
          if (res.ret === 0) {
            // 接口返回结构是 res.data.list，以及平级的 areaLevel
            const rawData = res.data && res.data.list;
            const areaLevel = res.data && res.data.areaLevel;

            // 应用全新的两层级联格式化逻辑
            const formattedData = formatTwoLevelRegion(rawData);

            context.commit('setCurrentVisualAreaLevel', areaLevel || '1');
            context.commit('setRawRegionTree', rawData); // 保存原始树结构
            context.commit('setAllRegionIncludeSelf', formattedData);
            resolve(formattedData);
          } else {
            reject(res);
          }
        }).catch(err => reject(err));
      });
    }
  }
};
